import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import styled from 'styled-components';
import { pxToRems } from '@awaze/design-system.utils.react';
import { DisclosureItemContext } from './disclosureItem.context';
const DisclosureCollapseStyled = styled.div `
  padding-bottom: ${pxToRems(12)};
  background-color: ${({ theme }) => theme.ColorWhiteOpacity100};
  position: absolute;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`;
export const DisclosureCollapse = ({ children, ...rest }) => {
    const { open } = useContext(DisclosureItemContext);
    return open ? (_jsx(DisclosureCollapseStyled, { ...rest, "data-testid": "Disclosure-collapse", children: children })) : null;
};
//# sourceMappingURL=disclosureCollapse.js.map